/** @jsx jsx */
import { jsx } from '@emotion/core';
import get from 'lodash/get';
import MapCard from '../MapCard';
import * as styles from './index.styles';

const Marker = props => {
  const location = get(props, 'fields.Location', {});
  const shouldShowHover = props.showTooltip || props.showHover;

  return (
    <div css={styles.marker}>
      <div css={styles.markerCard(props.showTooltip)}>
        <MapCard fields={props.fields}></MapCard>
      </div>
      <button
        css={styles.circle(shouldShowHover)}
        onClick={props.onClick}
        id={location.Id}
      />
      <div css={[styles.markerTitle(props.showTooltip)]}>{location.Name}</div>
    </div>
  );
};

const ClusterMarker = props => (
  <div css={styles.clusterMarker(props.showHover)}>{props.numPoints}</div>
);

const Markers = (clusters, onClick, selectedTooltip, hoverElement) =>
  clusters.map(item => {
    const id = get(item, 'points[0].Location.Id', '');

    if (item.numPoints === 1) {
      const showHover = id === hoverElement;
      const showTooltip = id === selectedTooltip;

      return (
        <Marker
          key={`marker-${id}`}
          lat={item.lat}
          lng={item.lng}
          fields={item.points[0]}
          onClick={onClick}
          showTooltip={showTooltip}
          showHover={showHover}
        />
      );
    }

    const showHover = item.points.some(
      point => point.Location.Id === hoverElement,
    );

    return (
      <ClusterMarker
        key={`cluster-marker-${id}`}
        lat={item.lat}
        lng={item.lng}
        numPoints={item.numPoints}
        showTooltip={false}
        showHover={showHover}
      />
    );
  });

export default Markers;
